import { Component, ChangeDetectionStrategy, effect, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { IconLoaderService } from '../../icon-loader.service';
import { PipelineProperty, ReportInfo, ReportView } from '../../models/report.model';
import { ReportAllRecordsImage } from '../../models/template.model';
import { ReportExportViewService } from '../../report-export-view.service';
import { ReportImagesService } from '../../report-images.service';
import { ActionsToolbarComponent } from '../presentation-view/actions-toolbar/actions-toolbar.component';

import { L10nTranslationModule } from 'angular-l10n';

import { DevelopmentPipelineViewImageComponent } from './rep-development-pipeline-view-image/development-pipeline-view-image.component';
import {
  MatTable,
  MatColumnDef,
  MatHeaderCellDef,
  MatHeaderCell,
  MatCellDef,
  MatCell,
  MatFooterCellDef,
  MatFooterCell,
  MatHeaderRowDef,
  MatHeaderRow,
  MatRowDef,
  MatRow,
  MatFooterRowDef,
  MatFooterRow,
} from '@angular/material/table';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'rep-development-pipeline-view',
  templateUrl: './development-pipeline-view.component.html',
  styleUrl: './development-pipeline-view.component.scss',
  imports: [
    ActionsToolbarComponent,
    L10nTranslationModule,
    DevelopmentPipelineViewImageComponent,
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatFooterCellDef,
    MatFooterCell,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    MatFooterRowDef,
    MatFooterRow
],
})
export class DevelopmentPipelineViewComponent {
  private readonly reportExportViewService = inject(ReportExportViewService);
  private readonly reportImagesService = inject(ReportImagesService);
  private readonly iconLoaderService = inject(IconLoaderService);
  private readonly router = inject(Router);

  displayedColumns: string[] = ['FLOOR', 'SQM', 'SQFT'];
  propertiesCount: number;
  property = {} as PipelineProperty;
  totalProperties: PipelineProperty[];
  showNavigationArrows: boolean = false;
  readonly reportData = input.required<ReportInfo>();
  readonly currentView = input.required<ReportView>();
  private lastFetchedImagesReportId: number | string | null = null;

  constructor() {
    effect(() => {
      const reportData = this.reportData();
      if (reportData?.reportId != null && reportData.reportId !== this.lastFetchedImagesReportId) {
        this.lastFetchedImagesReportId = reportData.reportId;
        this.fetchAdditionalImagesOfReport();
      }
      const properties = reportData.pipeline.map(pipeline => pipeline.properties);
      // flatten the nested array
      this.totalProperties = [].concat(...properties);
      this.propertiesCount = this.totalProperties.length;
      if (this.propertiesCount > 1) {
        this.property = this.totalProperties[0];
      }
    });
  }

  navRecordNum(event) {
    this.property = this.totalProperties[event - 1];
  }

  /**
   * this method is used to fetch the additional image id of the report.
   */
  private fetchAdditionalImagesOfReport() {
    this.reportExportViewService.getImages(this.reportData().reportId).subscribe((res: ReportAllRecordsImage) => {
      this.reportImagesService.setReportRecordImages(res);
    });
  }

  goToRecord() {
    const { entity } = this.reportData();
    const url = `/records/${entity}/${this.property.id}/edit`;
    window.open(url, '_blank');
  }
}
